module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Ruth Dudley Edwards\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_c('P', [_vm._v("Ruth Dudley Edwards is a historian and journalist as well as a mystery writer. The targets of her satirical crime novels include the gentlemen's clubs, Cambridge University, the House of Lords, journalism and literary prizes. The British Crime Writers' Association short-listed Corridors of Death for the John Creasy Award for best first novel, and Clubbed to Death and Ten Lords A-Leaping for their Last Laugh Award. She won the CrimeFest Last Laugh Award for Murdering Americans in 2008 and in 2010 the CWA Non-fiction Gold Dagger for Aftermath: the Omagh bombings and the families' pursuit of justice. Her twelfth mystery, Killing the Emperors, is a black comedy about conceptual art.")])], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/EK9DN9/tc-custom/9781615950577.jpg?1716663321611",
      "alt": "This image is the cover for the book Clubbed To Death, Robert Amiss/Baroness Jack Troutbeck Mysteries"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Clubbed To Death, Robert Amiss/Baroness Jack Troutbeck Mysteries\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Robert Amiss is persuaded by his friend Detective Sergeant Pooley of the CID to take a job as a waiter in ffeatherstonehaughs (pronounced Fanshaws), a gentlemen's club in St James. The club secretary has allegedly jumped to his death from the gallery of this imposing building. Against most of the evidence, Pooley believes he was murdered.")]), _c('p', [_vm._v("Amiss finds himself in a bizarre caricature of a club, run by and for debauched geriatrics, with skeletons rattling in every cupboard. Why are there so few members? How are they financed? Will Amiss keep his job despite the enmity of the ferocious, snuff-covered Colonel Fagg?")]), _vm._v(" "), _c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Poisoned Pen Press\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0